import { z } from 'zod';
import {
  formatAuthenticationStatusLabel,
  parseAuthenticationDetailsStreamOutput,
} from '@terra/shared-dto-chat-types';
import type { MetadataItem } from '../tool-config-types';

type MetadataExtractorContext = {
  input: unknown;
  output?: unknown;
  status?: string;
};

const AuthenticationDetailsInputSchema = z.object({
  credentialId: z.string(),
});

const isRunningStatus = (status?: string): boolean =>
  status === 'started' || status === 'in-progress';

const isErrorStatus = (status?: string): boolean => status === 'error';

export const extractAuthenticationDetailsCredentialId = (
  input: unknown,
): string | undefined => {
  const parsedInput = AuthenticationDetailsInputSchema.safeParse(input);
  if (!parsedInput.success) {
    return undefined;
  }

  return parsedInput.data.credentialId;
};

export const extractAuthenticationDetailsMetadata = ({
  output,
  status,
}: MetadataExtractorContext): MetadataItem[] => {
  if (isRunningStatus(status)) {
    return [];
  }

  if (isErrorStatus(status)) {
    return [{ label: 'Status', value: 'Failed' }];
  }

  const details = parseAuthenticationDetailsStreamOutput(output);
  if (!details) {
    return [];
  }

  if (details.authenticationStatus === 'AUTHENTICATED') {
    return [];
  }

  return [
    {
      label: 'Status',
      value: formatAuthenticationStatusLabel(details.authenticationStatus),
    },
  ];
};

export const hasAuthenticationDetailsExpandableContent = ({
  status,
}: MetadataExtractorContext): boolean => {
  if (isRunningStatus(status)) {
    return false;
  }

  return isErrorStatus(status);
};
